jQuery(document).ready(function($) {
  const locations = [
      {
      url : "/manhattan-beach",
      queries : [
        '90732','90266','90267','90261','90260', '90254', '90249', '90278',
      ],
      regex: RegExp(/Manhattan Beach/ig),
      name: 'Manhattan Beach'
    },
      {
      url : "/redondo-beach",
      queries : [
        '90254', '90277', '90278', '90505', '90503', '90504',
      ],
      regex: RegExp(/Redondo Beach/ig),
      name: 'Redondo Beach'
    },
      {
      url : "/marina-del-rey",
      queries : [
        '90296','90293','90292','90295','90294','90291','90094', '90066',
      ],
      regex: RegExp(/Marina Del Rey/ig),
      name: 'Marina Del Rey'
    },
      {
      url : "/marina-del-rey",
      queries : [
        '90296','90293','90292','90295','90294','90291','90094', '90066',
      ],
      regex: RegExp(/Marina Del Rey/ig),
      name: 'Marina Del Rey'
    },
      {
      url : "/westlake",
      queries : [
        '91361','91358','91359','91362','91377','91376',
      ],
      regex: RegExp(/Westlake/ig),
      name: 'Westlake'
    },
      {
      url : "/calabasas",
      queries : [
        '91302','91372','91364','91367','91308','91365',
      ],
      regex: RegExp(/Calabasas/ig),
      name: 'Calabasas'
    },
      {
      url : "/beverly-hills",
      queries : [
        '90210','90213','90209','90212','90035','90034','90064','90024', '90095', '90067','90211'
      ],
      regex: RegExp(/Beverly Hills/ig),
      name: 'Beverly Hills'
    },
      {
      url : "/brentwood",
      queries : [
        '90073','90213','90209', '90212', '90035', '90034', '90064', '90024', '90095','90067','90211', '90049'
      ],
      regex: RegExp(/brentwood/ig),
      name: 'Brentwood'
    },
      {
      url : "/santa-monica",
      queries : [
        '90409','90405','90401','90402','90403','90404','90408','90410','90407','90272',
      ],
      regex: RegExp(/Santa Monica/ig),
      name: 'Santa Monica'
    },
      {
      url : "/hollywood",
      queries : [
        '90068','90027','90093','90028','90038','90072','90029',
      ],
      regex: RegExp(/hollywood/ig),
      name: 'Hollywood'
    },
      {
      url : "/west-hollywood",
      queries : [
        '90209','90211','90048','90069','90036','90046','90038','90093',
      ],
      regex: RegExp(/west hollywood/ig),
      name: 'West Hollywood'
    },
      {
      url : "/encino",
      queries : [
        '91416','91316','91426','91436','91413','91403','91411','91356',
      ],
      regex: RegExp(/encino/ig),
      name: 'Encino'
    },
      {
      url : "/burbank",
      queries : [
        '91067','91617','91614','91604','91603','91610','91601','91602','91526','91523','91505','91503','91521','91506','91510','91508','91504','91502','91201','91221','91618','91608',
      ],
      regex: RegExp(/Burbank/ig),
      name: 'Burbank'
    },
      {
      url : "/newport-beach",
      queries : [
        '92612','92616','92697','92617','92658','92660','92625','92657','92662',
      ],
      regex: RegExp(/Newport Beach/ig),
      name: 'Newport Beach'
    },
      {
      url : "/newport-mesa",
      queries : [
        '92626','92627','92628','92659','92663',
      ],
      regex: RegExp(/Newport Mesa/ig),
      name: 'Newport Mesa'
    },
      {
      url : "/laguna-niguel",
      queries : [
        '92654','92653','92656','92690','92677','92607',
      ],
      regex: RegExp(/Laguna Niguel/ig),
      name: 'Laguna Niguel'
    },
      {
      url : "/irvine-the-market-place",
      queries : [
        '92654','92653','92656','92690','92677','92607',
      ],
      regex: RegExp(/Irvine Market Place/ig),
      name: 'Irvine Market Place'
    },
      {
      url : "/carmel-valley",
      queries : [
        '92130','92129','92172',
      ],
      regex: RegExp(/Carmel Valley/ig),
      name: 'Carmel Valley'
    },
      {
      url : "/irvine-harvard-place",
      queries : [
        '92612','92614','92619','92606','92707','92735',
      ],
      regex: RegExp(/Irvine Harvard Place/ig),
      name: 'Irvine Harvard Place'
    },
      {
      url : "/irvine-harvard-place",
      queries : [
        '92612','92614','92619','92606','92707','92735',
      ],
      regex: RegExp(/Irvine Harvard Place/ig),
      name: 'Irvine Harvard Place'
    },
      {
      url : "/el-segundo-delivery-kitchen",
      queries : [
        '90251','90303','90304','90301','90302','90309','90308','90306','90045','90080', '90245'
      ],
      regex: RegExp(/El Segundo/ig),
      name: 'El Segundo'
    },



  ];

  $storeFinderInput = $('#store-finder');
  $storeFinderInput.keyup(function(e){
    if (e.which == 13) {
      let input = $storeFinderInput.val();
      let locationMatch = locations.find(function(locationItem) {
        return locationItem.queries.includes(input) || locationItem.regex.test(input);
      })
      if (locationMatch) {
        dataLayer.push({
          'event': 'storeFinderTrigger',
          'location_triggered': `Store Finder Trigger - ${locationMatch.name}`
        });
        console.log('work')
        window.location.href = '/locations' + locationMatch.url;
      }
      else {
        $('#store-finder-tooltip').show()
        // $('#store-finder-tooltip').foundation('show');
        setTimeout(function(){
          $('#store-finder-tooltip').hide()
          // $('#store-finder-tooltip').foundation('hide');
        }, 3000);
      }
    }
  })

})
